import contactsTemplate from './contacts.html';
import contactDetailTemplate from './contactDetail.html';
import contactAddTemplate from './contactAdd.html';

/* @ngInject */
const ContactsConfig = ($stateProvider) => {
  $stateProvider
    .state('contacts', {
      url: '/contacts',
      template: contactsTemplate,
      controller: 'ContactsController',
      controllerAs: 'contacts',
      params: { campaignId: null, defaultTab: 'PACKAGE', callingPage:null}
    })
    .state('contactAdd', {
      url: '/contacts/add',
      template: contactAddTemplate,
      controller: 'ContactAddController',
      controllerAs: 'contactAdd',
      params: { investor: null, customCount: null, advindaCount: null }
    })
    .state('contactEdit', {
      url: '/contacts/edit/:contactId',
      template: contactAddTemplate,
      controller: 'ContactAddController',
      controllerAs: 'contactAdd',
      params: { customCount: null, advindaCount: null }
    })
    .state('contactsDetail', {
      url: '/contacts/:contactId',
      template: contactDetailTemplate,
      controller: 'ContactDetailController',
      controllerAs: 'contact',
      params: { isCustomerContact: false, customCount: null, advindaCount: null }
    })
    .state('customerContactsDetail', {
      url: '/contacts/customerContacts/:contactId',
      template: contactDetailTemplate,
      controller: 'ContactDetailController',
      controllerAs: 'contact',
      params: { isCustomerContact: true, customCount: null, advindaCount: null }
    });
};

export default ContactsConfig;



/** WEBPACK FOOTER **
 ** ./src/app/components/contacts/contacts.config.js
 **/